import React from 'react';
import { X } from 'lucide-react';
import '../styles/ViewItemModal.css';

const ViewItemModal = ({ viewingItem, setViewingItem }) => {
  return (
    <div
      className="modal-overlay"
      onClick={() => setViewingItem(null)}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setViewingItem(null)}
          className="modal-close"
        >
          <X size={20} />
        </button>

        <h3 className="modal-title">Item Details</h3>

        {/* Item Image */}
        <div className="item-image-container">
          <img
            src={viewingItem.image}
            alt={viewingItem.name}
            className="item-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '<div class="image-error">Image not available</div>';
            }}
          />
        </div>

        {/* Item Details Grid */}
        <div className="item-details-grid">
          <div className="detail-item">
            <div className="detail-label">ID</div>
            <div className="detail-value detail-id">
              #{viewingItem.id}
            </div>
          </div>

          <div className="detail-item">
            <div className="detail-label">Item Name</div>
            <div className="detail-value detail-name">
              {viewingItem.name}
            </div>
          </div>

          <div className="detail-row">
            <div className="detail-item">
              <div className="detail-label">Quantity</div>
              <div className="detail-value">
                {viewingItem.quantity}
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-label">Price</div>
              <div className="detail-value detail-price">
                ₹{viewingItem.price.toFixed(2)}
              </div>
            </div>
          </div>

          <div className="detail-item">
            <div className="detail-label">Category</div>
            <span className={`category-badge-modal ${viewingItem.category}`}>
              {viewingItem.category.replace('-', ' ')}
            </span>
          </div>

          <div className="detail-item">
            <div className="detail-label">Total Value</div>
            <div className="detail-value detail-total">
              ₹{(viewingItem.price * viewingItem.quantity).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewItemModal;